import React, { useState,useContext,useEffect } from 'react'
import {dataContext,toText,localestr,load,uid} from '../utils.js'
import UniTable from '../cmp/UniTable'
import FilterForm from '../cmp/FilterForm' //+
import Menu from '../cmp/menu'
import icon from '../icons.svg'
//import MsgForm from '../cmp/msgForm.js'

function IrgTimekeepingList({data=undefined,actions,choice=false}){
    //const type='irgTimekeeping'
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    //const tabNew=actions.tabNew
    const tabClose=actions.tabClose
    const tabChoice=actions.tabChoice
    const tblPos=actions.tblPos  //Таблиця
    const isActive=actions.isActive  //Таблиця
    const setGlData=actions.setGlData
    const getGlData=actions.getGlData

    const context=useContext(dataContext)
    let table=undefined
    if(wndData) table=wndData.table
    //const Data=context.data[type]
    //const getData=context.getData
    //const saveData=context.saveData
    //const updateData=context.updateData
    const msg=context.msg
    const inputRange=context.inputRange
    const inputCols=context.inputCols
    const setSettings=context.setSettings
    const getSettings=context.getSettings
    const usersettings=getSettings()

    let from=new Date()
    from.setDate(1)
    from.setHours(0,0,0,0)
    let to=new Date()
    to.setHours(23,59,59,999)
    if (usersettings){
        if (usersettings.irgTimekeeping){
            if (usersettings.irgTimekeeping.from) from=usersettings.irgTimekeeping.from
            if (usersettings.irgTimekeeping.to && to-usersettings.irgTimekeeping.to>172860000) to=usersettings.irgTimekeeping.to
        }
    }
    if (wndData.from) from=wndData.from
    if (wndData.to) to=wndData.to
    if (typeof from==='string') from=new Date(from)
    if (typeof to==='string') to=new Date(to)
    if(wndData&&wndData.currentCol&&wndData.currentCol.date){
        let cur_from=wndData.currentCol.date
        if (typeof cur_from==='string') cur_from=new Date(cur_from)
        if(cur_from.getTime()<from.getTime()) from=cur_from
    }

    const [edit, setEdit2] = useState(false)
    const setEdit=(d)=>{setGlData({edit:d});setEdit2(d)}
    //const [isActive2, setisActive] = useState(false)

    const cols=[
        //{caption:'icon',minWidth:'20',dataId:'catDeps',sortable:false,typeVal:'submit',setFn:()=>{saveValue()}},
        //{caption:'id',minWidth:'12',dataId:'id',sortable:true},
        {caption:localestr('Дата'),minWidth:'160',dataId:'date',sortable:true,typeVal:'date',setFn:(d)=>{setVal('date',d)}},
        {caption:localestr('Працівник'),minWidth:'140',dataId:'employee',sortable:true,typeVal:'catEmployees',setFn:(d)=>{setVal('employee',d)}},
        {caption:localestr('Початок'),minWidth:'160',dataId:'start',sortable:true,typeVal:'text',setFn:(d)=>{setVal('start',d)}},
        {caption:localestr('Закінчення'),minWidth:'160',dataId:'finish',sortable:true,typeVal:'text',setFn:(d)=>{setVal('finish',d)}},
        //{caption:localestr('Відпрацьовано'),minWidth:'160',dataId:'worked',sortable:true,typeVal:'submit',setFn:()=>{saveValue()}},
        {caption:localestr('Відпрацьовано'),minWidth:'160',dataId:'worked',sortable:true},
    ]

    if(usersettings.CatDepartmentsList&&usersettings.CatDepartmentsList.cols){
        for(let i=0;i<usersettings.CatDepartmentsList.cols.length;i++){
            const idx=cols.findIndex(el=>el.dataId===usersettings.CatDepartmentsList.cols[i])
            if(idx!==-1) cols[idx].hiden=true
        }
    }

    const filterData=[ //+
        {caption:localestr('Дата'),dataId:'date',typeVal:'date'},
        {caption:localestr('Працівник'),dataId:'employee',typeVal:'catEmployees'},
        {caption:localestr('Початок'),dataId:'start',typeVal:'text'},
        {caption:localestr('Закінчення'),dataId:'finish',typeVal:'text'},
        {caption:localestr('Відпрацьовано'),dataId:'worked',typeVal:'text'}
    ]

    const setFilter=(id,val,type)=>{
        let filter=[...(wndData.filter||[])]
        const idx=filter.findIndex(el=>el.dataId===id)
        if(idx!==-1){
            if(!val) filter.splice(idx,1)
            else filter[idx].value=val
        } else if(val) filter.push({dataId:id, compare:'lk', value:val, typeVal:type})
        if (!filter.length) filter=undefined
        setWndData({...wndData,filter})
        setGlData({needFocus:1})
        tblPos(0)
    }

    const showHideFilter=()=>{
        const showAFilter=!wndData.showAFilter
        if(!showAFilter) setWndData({...wndData,filter:undefined,showAFilter})
        else setWndData({...wndData,showAFilter})
    }

    const loadData=(d)=>{
        if (d) {
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            setWndData({...wndData,table:d.data})
        } else {
            wndData=actions.getWndData()
            if (wndData.from) from=wndData.from
            if (wndData.to) to=wndData.to
            load('action=jrnTimeKeeping&data='+JSON.stringify({from,to}),(dt)=>{loadData(dt)})
        }

    }

    function time_to_str(d,timezoneOffset){
        let t=parseInt(d||0)||0
        if(!t) return ''
        else t-=timezoneOffset
        let hr=parseInt(t/60)
        let mn=t-hr*60
        if(hr>99) return ''+hr+':'+('00'+mn).slice(-2)
        return ('00'+hr).slice(-2)+':'+('00'+mn).slice(-2)
    }

    function str_to_time(d,timezoneOffset){
        let hr=''
        let mn=''
        const buf=''+d
        let f=true
        for(let i=0;i<buf.length;i++){
            const code=buf[i].charCodeAt()
            if(code>47&&code<58){ //число
                if(f&&hr.length<2) hr+=buf[i]
                else mn+=buf[i]
                if(hr.length>1) f=false
            } else {
                if(hr.length) f=false
            }
        }
        if(hr||mn) return parseInt(hr||0)*60+parseInt(mn||0)+timezoneOffset
        else return null
    }

    const listFromData=(currentCol,setCurrCol)=>{
        let list=[]
        if (table) list=table.map((item)=>{
            const timezoneOffset = (new Date(item.date)).getTimezoneOffset()
            let finish=parseInt(item.finish||0)
            if(finish>1440) finish-=1440
            const newItem={id:item.id,date:item.date,employee:{id:item.employee_id,name:item.employee},start:time_to_str(item.start,timezoneOffset),
                finish:time_to_str(finish,timezoneOffset),worked:time_to_str(parseInt(item.finish||timezoneOffset)-parseInt(item.start||timezoneOffset),0)}
            if (typeof currentCol !== 'undefined' && currentCol.id===item.id) setCurrCol({...newItem})
            return newItem})
        return list
    }

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) 
        setWndData({...wndData,list,sorting,currentCol})
    }

    const setHidenCols=(data)=>{
        if(data){
            const new_data=data.filter(el=>el.hiden).map(el=>el.dataId)
            setSettings({IrgTimekeepingList:{cols:new_data}})
        } else {
            inputCols(cols,setHidenCols)
        }
    }

    const filter=(fltr)=>{
        let showFilter=!wndData.showFilter
        let filter=wndData.filter
        if (fltr!==undefined) filter=fltr
        if(showFilter || fltr===undefined) setWndData({...wndData,showFilter,filter})
        else{
            setWndData({...wndData,showFilter,filter,currentCol:undefined})
            setGlData({needFocus:1})
            tblPos(0)
        }
    }

    const setVal=(name,data)=>{
        const list=wndData.list
        const sorting=wndData.sorting
        let currentCol=wndData.currentCol
        //if(name==='printer' && data.device) if(parseInt(data.device.value)>3) {msg(localestr('Недопустимий тип пристрою'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
        currentCol[name]=data
        setWndData({...wndData,list,sorting,currentCol})
    }

    const newItem=()=>{
        if (edit) return
        let currentCol={uid:uid(),id:'',date:(new Date()).toISOString().substring(0,10)}
        const list=wndData.list.concat(currentCol)
        setWndData({...wndData,list,currentCol})
        setEdit(true)
    }
    
    const copyItem=()=>{
        if (edit) return
        if (typeof wndData.currentCol === 'object') {
            let currentCol={...wndData.currentCol}
            delete currentCol.id
            const list=wndData.list.concat(currentCol)
            setWndData({...wndData,list,currentCol})
            setEdit(true)
        }
    }

    const editItem=()=>{
        if (edit) return
        if (!wndData.currentCol) return
        const currentCol={...wndData.currentCol}
        const oldCol={...wndData.currentCol}
        setWndData({...wndData,currentCol,oldCol})
        setEdit(true)
    }

    const editClick=()=>{
        if (typeof wndData.currentCol === 'object') {
            if(choice) {tabChoice(wndData.currentCol);tabClose()}
            else editItem()
        }
    }
            
    const removeItem=(data)=>{
        if (edit) return
        if(data){
            if (data.status==='error') {msg(data.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (data.status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            let table=wndData.table||[]
            let list=wndData.list||[]
            if(data.status==='delIrg') {
                table=table.filter(el=>el.id!==data.id)
                list=list.filter(el=>el.id!==data.id)
                setWndData({...wndData,table,list})
            }
        } else {
            if (typeof wndData.currentCol === 'object') {
                //let newData={status:'rem',key:'TimeKeeping',data:{id:wndData.currentCol.id,marked:(wndData.currentCol.marked==='0'?'1':'0')}}
                //saveData(newData,d=>removeItem(d))
                load('action=remTimeKeeping&data='+JSON.stringify({id:wndData.currentCol.id}),(dt)=>{removeItem(dt)})
            }
        }
    }

    /*const objHistory=()=>{
        if (typeof wndData.currentCol === 'object') {
            tabNew('repObjHistory',localestr('Історія змін')+' '+toText(wndData.currentCol['name']),{object:{...wndData.currentCol,type:type}},true)
        }
    }*/
        
    const setCol=(currentCol)=>{
        /*if (edit) return
        setisActive(true)
        setWndData({...wndData,currentCol})*/
        if (currentCol.id === wndData.currentCol?.id) return
        if ((getGlData()||{}).edit) {saveValue(()=>{setCol(currentCol)});return}
        setWndData({...wndData,currentCol})
        setGlData({needFocus:0})
    }
        
    const cancelEdit=()=>{
        //sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        //setEdit(false)

        setEdit(false)
        const newData=actions.getWndData()
        if(newData.oldCol){
            newData.currentCol={...newData.oldCol}
            newData.oldCol=undefined
            newData.list=newData.list.map(el=>el.uid!==newData.currentCol.uid?el:{...newData.currentCol})
            
        } else {
            const list=newData.list.filter(el=>el.uid!==newData.currentCol.uid)
            setWndData({...wndData,list,currentCol:undefined,oldCol:undefined})
        }
    }

    const saveValue=(d)=>{
        if(d){
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            loadData()
            setEdit(false)
        }
        else{
            let errmsg=''
            if (typeof wndData.currentCol === 'object') {
                const date=wndData.currentCol.date
                const timezoneOffset = (new Date(date)).getTimezoneOffset()
                const employee=wndData.currentCol.employee
                const start=str_to_time(wndData.currentCol.start,timezoneOffset)
                const finish=str_to_time(wndData.currentCol.finish,timezoneOffset)||''

                if (date===null || date==='') errmsg=localestr("Не заповнено дату")
                if (employee===null || employee==='') errmsg=errmsg+' '+localestr("Не заповнено працівника")
                if (start===null || start==='') errmsg=errmsg+' '+localestr("Не заповнено початок")
                if (errmsg!=='') alert(errmsg)
                else{
                    let id=wndData.currentCol.id
                    let item={date,employee:{id:employee.id},start,finish}
                    if(id) item.id=id
                    load('action=modTimeKeeping&data='+JSON.stringify(item),(dt)=>{saveValue(dt)})
                    /*if (id===null || id==='' || id===undefined){
                        let newData={status:'add',key:type,data:item}
                        //saveData(newData,()=>{})
                        setEdit(false)
                    }  
                    else {
                        item.id=id
                        let newData={status:'mod',key:type,data:item}
                        //saveData(newData,()=>{})
                        setEdit(false)
                    } */       
                }
            }
        }
    }

    const range=(frm,to_)=>{
        //let showRange=!wndData.showRange
        let froml=from
        let tol=to
        if (frm!==undefined) froml=frm
        if (to_!==undefined) tol=to_
        let Datal=table
        if (froml!==from || tol!==to) {
            //loadData()
            Datal=undefined
        }
        //setWndData({...wndData,showRange,from:froml,to:tol,table:Datal})
        setWndData({...wndData,from:froml,to:tol,table:Datal})
        setSettings({irgTimekeeping:{from:froml,to:tol}})
    }

    const anyKey=(key)=>{
        if(key==='Delete') removeItem()
        else if(key==='Insert') newItem()
        else if(key==='F9') copyItem()
        else if(key==='Escape') cancelEdit()
        else if(key==='shift_F4') tabClose()
        else if(key==='F2') filter()
        //else console.log(key)
    }

    const needFocus=(reset=true)=>{   //Таблиця
        if(isActive()===false) return -1
        const glData=getGlData()||{}
        const needFocus=glData.needFocus
        if(needFocus===undefined) return -1
        if(reset) setGlData({needFocus:-1})
        return needFocus
    }

    const tick=()=>{
        if (edit) return
        wndData=actions.getWndData()
        if (wndData.showRange) return
        loadData()
    }


    useEffect(() => {
        if (edit) return
        if (typeof table === 'undefined') loadData()
        else if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('date','asc',undefined)
    // eslint-disable-next-line 
    },[table])

    useEffect(() => {
        //console.log('effect2')
        const intervalHandle=setInterval(tick,30000)
        return () => clearInterval(intervalHandle)
    // eslint-disable-next-line 
    },[])
    

    const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
    const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter}/> : ''  //+

    const menuData=[
        {name:localestr('Налаштування таблиці'),icon:'#b953',action:setHidenCols},
        {name:localestr('Фільтр'),icon:'#b955',action:filter},
        {name:localestr('Друк списку'),icon:'#b503',action:()=>{window.print()}},
        //{name:localestr('Історія змін'),icon:'#hisBut',action:objHistory},
        //{name:localestr('Остаточне видалення'),icon:'#remBut',action:clrCatalog},
        {name:localestr('Оновити список'),icon:'#b954',action:()=>{loadData()}},
    ]
    //if(choice) menuData.splice(2,3)

    return(
        <>
        <div style={{display:'flex',flexDirection:'column',height:'calc(100% - 3px)'}}>
        <div className='toolBar no-print'>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати')+' (Ins)'} 
            onClick={newItem}
            onKeyUp={(e)=>{if(e.key === 'Enter') newItem()}}><img src={icon+'#addBut'} alt={localestr('Додати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Редагувати')} 
            onClick={()=>{editItem()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') editItem()}}><img src={icon+'#editBut'} alt={localestr('Редагувати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Копіювати')+' (F9)'} 
            onClick={copyItem} onKeyUp={(e)=>{if(e.key === 'Enter') copyItem()}}
            ><img src={icon+'#copyBut'} alt={localestr('Копіювати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')+' (Del)'}
            onClick={()=>{removeItem()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') removeItem()}}><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>
            <div  tabIndex='0' className='toolBarSeparator'></div>
            <div tabIndex='0' onClick={()=>{inputRange(from,to,range)}} onKeyUp={(e)=>{if(e.key === 'Enter') range()}}
                style={{alignSelf:'center',lineHeight:'30px',height:'30px',width:'192px',padding:'0px 2px 0 6px',userSelect:'none',cursor:'pointer',color:'#FFF',background:'url('+icon+'#btn185v) no-repeat',backgroundSize:'192px 30px'}}>
                {toText(from)}-{toText(to)}
                <img style={{width:'24px',height:'24px',verticalAlign:'middle'}} src={icon+'#cal_w'} alt={localestr('Інтервал дат')} />
            </div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}  
            onClick={()=>{showHideFilter()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') showHideFilter()}}><img src={icon+'#filtBut'} alt={localestr('Автофільтр')} /></div>
            <div style={{flexGrow:'10'}}></div>

            <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
                <img className='toolBarIcon' src={icon+'#dnBut'} alt='' />
            </Menu></div>
            
        </div>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{...wndData.currentCol,edit}} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} openHandle={editClick} keyHandle={anyKey} saveHandle={()=>saveValue()} cancelHandle={cancelEdit} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus}/>
        </div>
        {showFilter}
        </>
    )
    
}

export default IrgTimekeepingList